import { render, staticRenderFns } from "./vistacreditos.vue?vue&type=template&id=177b58e1&"
import script from "./vistacreditos.vue?vue&type=script&lang=js&"
export * from "./vistacreditos.vue?vue&type=script&lang=js&"
import style0 from "./vistacreditos.vue?vue&type=style&index=0&id=177b58e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports